import React, { type FC, lazy, Suspense } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'

import Loader from 'components/Loader'

import { ROOT_ROUTE_PATTERN } from 'constants.app'
import { configs } from 'environment'
import { Pages } from 'pages'

const Home = lazy(async () => await import('pages/Home'))
const PlanSelection = lazy(async () => await import('pages/PlanSelection'))
const EditConnectionDetails = lazy(async () => await import('pages/EditConnectionDetails'))
const BillerSelection = lazy(async () => await import('pages/BillerSelection'))
const ConsumerIdentification = lazy(async () => await import('pages/ConsumerIdentification'))
const Checkout = lazy(async () => await import('pages/Checkout'))
const PaymentSuccess = lazy(async () => await import('pages/PaymentSuccess'))
const PaymentFailure = lazy(async () => await import('pages/PaymentFailure'))
const Contacts = lazy(async () => await import('pages/Contacts'))
const Error = lazy(async () => await import('pages/Error'))
const Config = lazy(async () => await import('pages/Config'))
const Bills = lazy(async () => await import('pages/Bills'))
const Master = lazy(async () => await import('pages/Master'))
const RechargesHome = lazy(async () => await import('pages/RechargesHome'))
const AllBillsNRecharges = lazy(async () => await import('pages/AllBillsNRecharges'))

const AppRouter: FC = () => {
  return (
    <BrowserRouter>
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path={`${ROOT_ROUTE_PATTERN}`}>
            <Route path={Pages.LANDING} element={<Home />} />
            <Route path={Pages.CUG_HOME} element={<Home />} />
            <Route path={Pages.HOME} element={<RechargesHome />} />
            <Route path={Pages.RECHARGES_HOME} element={<RechargesHome />} />
            <Route path={Pages.PLAN_SELECTION} element={<PlanSelection />} />
            <Route path={Pages.EDIT_CONNECTION} element={<EditConnectionDetails />} />
            <Route path={Pages.BILLER_SELECTION} element={<BillerSelection />} />
            <Route path={Pages.CONSUMER_IDENTIFICATION} element={<ConsumerIdentification />} />
            <Route path={Pages.BILLS} element={<Bills />} />
            <Route path={Pages.BILL_DETAILS} element={<Bills />} />
            <Route path={Pages.CHECKOUT} element={<Checkout />} />
            <Route path={Pages.CONTACTS} element={<Contacts />} />
            <Route path={Pages.ERROR} element={<Error />} />
            <Route path={Pages.PAYMENT_SUCCESS} element={<PaymentSuccess />} />
            <Route path={Pages.PAYMENT_FAILURE} element={<PaymentFailure />} />
            <Route path={Pages.ALL_BILLS_RECHARGES} element={<AllBillsNRecharges />} />
            {!configs.isProd && <Route path='config' element={<Config />} />}
            <Route path='*' element={<Master />} />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  )
}

export default AppRouter
